import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import ExploreDealMarketplaceReducer from "./ExploreDealsSlice"; // used for social logins
import ChatFlagReducer from "./ChatFlagSlice"; // used - All Messages, order related

// Persist configuration
const persistConfig = {
  key: "CouponAndVoucherDetail",
  version: 1,
  storage,
};

// Persisted reducer
const persistedReducer = persistReducer(
  persistConfig,
  ExploreDealMarketplaceReducer
);

// Store configuration
const store = configureStore({
  reducer: {
    ChatFlag: ChatFlagReducer,
    CouponAndVoucherDetail: persistedReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
